<template>
  <b-form-checkbox
    :key="key"
    :value="1"
    :unchecked-value="0"
    :checked="checked"
    :disabled="disabled"
    size="lg"
    @change="setVote"
  />
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      require: true,
    },
    type: {
      type: Number,
      require: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    meetingCorrespondenceVotes: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      key: 0,
    };
  },
  computed: {
    checked() {
      if (this.currentVote) {
        return this.currentVote == this.type ? 1 : 0;
      } else {
        return 0;
      }
    },
    majorityId() {
      return this.data.item.majority_id;
    },
    meetingResolutionId() {
      return this.data.item.id;
    },
    currentVote() {
      let proposed_votes = this.meetingCorrespondenceVotes.proposed_votes;
      if (proposed_votes && proposed_votes.length > 0) {
        let existentVoteIndex = this.$_.findIndex(proposed_votes, item => {
          return (
            item.majority_id == this.majorityId &&
            item.meeting_resolution_id == this.meetingResolutionId
          );
        });
        if (existentVoteIndex != "-1") {
          return proposed_votes[existentVoteIndex].vote;
        } else {
          return null;
        }
      } else {
        return null;
      }
    },
  },
  methods: {
    setVote() {
      this.$emit("setProposedVote", {
        majorityId: this.majorityId,
        meetingResolutionId: this.meetingResolutionId,
        vote: this.type,
      });
    },
  },
};
</script>
